import React from 'react';
import { V2TextInput } from '@abyss/web/ui/TextInput';
import { Grid } from '@abyss/web/ui/Grid';
import { DeleteButton } from '@src/components/global/DeleteButton';
import { DetailWrapper } from '@src/components/global/DetailWrapper';
import { ThemeDetailController } from './ThemeDetail.Controller';
import { V2Toggle } from '@abyss/web/ui/Toggle';

export const ThemeDetail = () => {
  const { form, pageData, Action, pageTop, params, fieldsDisabled } =
    ThemeDetailController();
  return (
    <DetailWrapper
      data={pageData.detailResponse}
      form={form}
      formData={pageData.item}
      onSave={Action.Save}
    >
      <div ref={pageTop}>
        <Grid>
          <Grid.Col span={{ sm: 12, md: 12, lg: 4 }}>
            <V2TextInput
              label="Name"
              model="name"
              maxLength={250}
              validators={{
                required: 'Name is required',
              }}
              isDisabled={pageData.isEdit}
            />
            <V2Toggle
              label="Active"
              model="isActive"
              isDisabled={fieldsDisabled}
              css={{ 'abyss-toggle-root': { marginTop: '$md' } }}
            />
          </Grid.Col>
          <Grid.Col span={{ sm: 12, md: 2, lg: 6 }}></Grid.Col>
        </Grid>
        <DeleteButton
          params={params}
          delete={Action.OnDeleteConfirm}
          isDisabled={fieldsDisabled}
        />
      </div>
    </DetailWrapper>
  );
};
